import React from 'react';

export const DoublePleat = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#prefix__b)"
        fill="#96b0bb"
        stroke="#233762"
        strokeWidth={0.689}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M-1.2 20.5h92.9v72.7H-1.2z"
      />
      <g clipPath="url(#prefix__b)">
        <path
          d="M69.2 43.9c-1.2 4.2-3.8 21-3.3 49.3h-3.3c-.1-17.5 1.3-46 4.5-52.1 0 0-.7-17.4-.6-20.3s2.6-1.5 2.7-.7"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M69.2 20.1c.1-.8 2.6-2.2 2.7.7s-.6 20.3-.6 20.3c3.3 6.1 4.6 34.6 4.5 52.1h-3.3c.5-28.2-2.1-45.1-3.3-49.3"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M69.2 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <g clipPath="url(#prefix__b)">
        <path
          d="M85.1 20.1c-.1-.8-2.6-2.2-2.7.7-.1 2.9.6 20.3.6 20.3-3.3 6.1-4.6 34.6-4.5 52.1h3.3C81.3 65 84 48.1 85.1 43.9"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M85.1 43.9c1.2 4.2 3.8 21 3.3 49.3h3.3c.1-17.5-1.3-46-4.5-52.1 0 0 .7-17.4.6-20.3s-2.6-1.5-2.7-.7"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M85.1 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <g clipPath="url(#prefix__b)">
        <path
          d="M53.3 43.9c-1.2 4.2-3.8 21-3.3 49.3h-3.3c-.1-17.5 1.3-46 4.5-52.1 0 0-.7-17.4-.6-20.3.1-2.8 2.6-1.5 2.7-.7"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M53.3 20.1c.1-.8 2.6-2.2 2.7.7.1 2.8-.6 20.3-.6 20.3 3.3 6.1 4.6 34.6 4.5 52.1h-3.3c.5-28.2-2.2-45.1-3.3-49.3"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M53.3 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <g clipPath="url(#prefix__b)">
        <path
          d="M37.3 43.9c-1.2 4.2-3.8 21-3.3 49.3h-3.3c-.1-17.5 1.3-46 4.5-52.1 0 0-.7-17.4-.6-20.3s2.6-1.5 2.7-.7"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M37.3 20.1c.1-.8 2.6-2.2 2.7.7s-.6 20.3-.6 20.3c3.3 6.1 4.6 34.6 4.5 52.1h-3.3c.5-28.2-2.2-45.1-3.3-49.3"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M37.3 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <g clipPath="url(#prefix__b)">
        <path
          d="M21.4 43.9c-1.2 4.2-3.8 21-3.3 49.3h-3.3c-.1-17.5 1.3-46 4.5-52.1 0 0-.7-17.4-.6-20.3.1-2.8 2.6-1.5 2.7-.7"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M21.4 20.1c.1-.8 2.6-2.2 2.7.7s-.6 20.3-.6 20.3c3.3 6.1 4.6 34.6 4.5 52.1h-3.3c.5-28.2-2.2-45.1-3.3-49.3"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M21.4 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <g clipPath="url(#prefix__b)">
        <path
          d="M5.5 43.9c-1.2 4.2-3.8 21-3.3 49.3h-3.3c-.1-17.5 1.3-46 4.5-52.1 0 0-.7-17.4-.6-20.3.1-2.8 2.6-1.5 2.7-.7M5.5 20.1c.1-.8 2.6-2.2 2.7.7s-.6 20.3-.6 20.3c3.3 6.1 4.6 34.6 4.5 52.1H8.8C9.3 65 6.6 48.1 5.5 43.9"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.689}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M5.5 22.6c-.3 3.1-.8 17.3 0 17.3s0-17.3 0-17.3z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.632}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
      </g>
      <path
        d="M81.8 93.2C81.3 65 84 48.1 85.1 43.9c1.2 4.2 3.8 21 3.3 49.3h-6.6zM65.8 93.2C65.4 65 68 48.1 69.2 43.9c1.2 4.2 3.8 21 3.3 49.3h-6.7zM50 93.2c-.5-28.2 2.2-45.1 3.3-49.3 1.2 4.2 3.8 21 3.3 49.3H50zM34 93.2c-.5-28.2 2.2-45.1 3.3-49.3 1.2 4.2 3.8 21 3.3 49.3H34zM18 93.2c-.5-28.2 2.2-45.1 3.3-49.3 1.2 4.2 3.8 21 3.3 49.3H18zM2.1 93.2C1.6 65 4.3 48.1 5.4 43.9c1.2 4.2 3.8 21 3.3 49.3H2.1z"
        clipPath="url(#prefix__b)"
        fill="#233762"
        stroke="#233762"
        strokeWidth={0.689}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
